import { useEffect, useMemo, useState } from "react"
import { RoutePath, useRoutesHooks } from "../../../../../features/routes"
import { PanelLoader, useGetCrumbs, useUIStateActions } from "../../../../../features/ui"
import { operationHelpers } from "../../../../operations"
import { Customer, SaleOperation, useCustomerLoaders, EmitFinancialDeliveryOrderFormLoader } from "../../../../sales"
import { TableName } from "../../../../../tables"
import { EmitDeliveryOrderForm } from "./emitDeliveryOrderForm"
import { hoardHelpers } from "../../../../sales/hooks/hoardHooks"

export const EmitDeliveryOrderFormLoader = () => {
    const { tableName, dataType } = useRoutesHooks().parseUrl()
    const table = tableName! as TableName
    const operation = dataType! as SaleOperation
    
    const [ready, setReady] = useState(false)
    const [customer, setCustomer] = useState<Customer>()
    
    const { describeCode } = operationHelpers
    
    const customerLoaders = useCustomerLoaders()
    
    const { setDisableBranchSelector } = useUIStateActions()
    
    const isSale = useMemo(() => table === TableName.SALE_ORDERS, [table])
    const isFinancialHoard = useMemo(() => hoardHelpers.isFinancialHoard(table, operation), [table, operation])

    const load = async () => {
        const { loadCustomer } = customerLoaders()
        const loadedCustomer = await loadCustomer(operation.customerId)
        setCustomer(loadedCustomer)
    }

    useEffect(() => {
        setDisableBranchSelector(true)
        load().then(() => setReady(true))
        return () => {
            setDisableBranchSelector(false)
        }
    }, [])

    const title = useMemo(() => `Emitir Entrega ${describeCode(operation)}`, [operation])
    const crumbs = useGetCrumbs(
        isSale ? 'Ventas' : 'Acopios',
        isSale ? RoutePath.SALES : RoutePath.HOARDS,
        describeCode(operation),
        operation.id,
        'Emitir Entrega'
    )

    if (isFinancialHoard) {
        return <EmitFinancialDeliveryOrderFormLoader />
    }

    return (
        <PanelLoader
            title={title}
            crumbs={crumbs}
            ready={ready}
            wide
        >
            <EmitDeliveryOrderForm
                table={table}
                operation={operation}
                customer={customer!}
            />
        </PanelLoader>
    )
}
